const { EVENT } = require('../constants');

const utils = (storeUtils = window.flex) => {

    const { trigger } = storeUtils;

    function addPageAlerts(alerts) {
        // sample alerts: { summary: "", detail : "", disableClose: false, isModal: false, className: "alert-danger|alert-info|alert-warning|alert-success" }
        // see appContainer.jsx and pageAlerts.jsx to modify look and feel of page alerts
        if (!alerts) {
            return;
        }
        trigger(EVENT.GLOBAL.ADD_PAGE_ALERTS, alerts);
    }

    function addPageModalContent (content) {
        // sample alerts: {summary: "", disableClose: false, isModal: false, className: "alert-danger|alert-info|alert-warning|alert-success" }
        // see appContainer.jsx and pageAlerts.jsx to modify look and feel of page alerts
        if (!content) {
            return;
        }
        trigger(EVENT.GLOBAL.ADD_PAGE_MODAL_CONTENT, content);
    }

    function loadConfigCodes(codeKinds, success, fail) {
        if(!codeKinds) {
            return;
        }
        trigger(EVENT.GLOBAL.LOAD_CONFIG_CODES, codeKinds, success, fail);
    }

    function navigate(url, replace) {
        trigger(EVENT.GLOBAL.NAVIGATE, {url, replace});
    }

    function removePageAlerts(alerts, postId) {
        if (!alerts) {
            return;
        }
        trigger(EVENT.GLOBAL.REMOVE_PAGE_ALERTS, alerts, postId);
    }

    function removePageModalContent (content, postId) {
        if (!content) {
            return;
        }
        trigger(EVENT.GLOBAL.REMOVE_PAGE_MODAL_CONTENT, content, postId);
    }

    return {
        addPageAlerts,
        addPageModalContent,
        loadConfigCodes,
        navigate,
        removePageAlerts,
        removePageModalContent
    };
}

module.exports = utils;